module.exports = __webpack_public_path__ + "static/media/avatar-640696bb46a8522a2ed9bef17d9507cd6.webp";